<template>
  <div class="video-parent" :entity="entity">
    <div
      v-show="!matchEntities(['POLAND'])"
      @click="toggleVideoPlayer('assets/help/connect_intcable.mp4')"
      class="video-wrapper"
    >
      <p>{{ $t('charge_help.section2_video1') }}</p>
      <div
        class="video-border"
        style="background-image: var(--integrated-start-thumbnail);"
      >
        <div class="play-circle"></div>
      </div>
    </div>
    <div
      @click="toggleVideoPlayer('assets/help/connect_car_cable.mp4')"
      class="video-wrapper"
    >
      <p v-show="!matchEntities(['POLAND'])">
        {{ $t('charge_help.section2_video2') }}
      </p>
      <div
        class="video-border"
        style="background-image: var(--car-cable-thumbnail);"
      >
        <div class="play-circle"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { entity } from '@/../region.json';
import matchEntities from '../../shared/entityHelpers';

export default {
  name: 'PlugCar',
  props: ['toggleVideoPlayer'],
  data() {
    return { entity };
  },
  methods: {
    matchEntities,
  },
};
</script>

<style scoped>
.video-parent {
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
}
.video-parent[entity='POLAND'] {
  grid-template-columns: 1fr;
}
.video-wrapper {
  display: grid;
  grid-template-rows: auto 1fr;
  --integrated-start-thumbnail: url(~@/assets/help/integrated-cable-start.svg);
  --car-cable-thumbnail: url(~@/assets/help/car-cable-img.svg);
  --integrated-end-thumbnail: url(~@/assets/help/integrated-cable-end.svg);
}
.video-wrapper p {
  font-weight: bold;
  color: #2b4047;
  margin: 0 0 10px 0;
}
.video-border {
  grid-row: 2;
  grid-column: 1;
  height: 190px;
  align-self: flex-start;
  padding: 0 5px;
  border-radius: 10px;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  width: 95%;
  margin-bottom: 100px;
  background-position: center;
}
.video-border > * {
  grid-area: 1 / 1;
}
.play-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 52px;
  height: 52px;
  background: url(~@/assets/help/play-button.svg);
  background-repeat: no-repeat;
  object-fit: cover;
  object-position: left top;
}
</style>
